<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="-two-columns">
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Utilisateurs</h1>
                        <listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            :deletedShowable="true"
                            :showDeleted="showDeleted"
                            @set-show-deleted="showDeleted=$event"
                            :sorted="true"
                            :loading="loadingUserProfiles"
                        >
                            <template v-slot:select-filter>
                                <Select
                                    class="q-mt-xs"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    :options="roleFilterOptions"
                                    fill-input
                                    emit-value
                                    :clearable="false"
                                    v-model="filterByRole"
                                    label="Filtrer par rôle"
                                ></Select>
                            </template>
                        </listbox>
                        <q-checkbox class="-showDeleted" size="22px" v-model="orderByHiringDate" label="Trier par ancienneté" />

                        <!-- <listbox
                            v-show="!$apollo.loading"
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted=$event"
                        /> -->
                    </div>
                </div>
                <div class="o-col w-2/3">
                <!-- <div class="o-col w-2/3" v-if="!$apollo.loading"> -->
                    <q-banner rounded inline-actions class="text-white bg-red q-mb-lg" v-if="form.id && (form.role=='PARTNER' || (form.role.value && form.role.value=='PARTNER')) && (!form.company.contact_email || form.company.contact_email=='')">
                        <div>
                            Attention, ce compte est défini comme compte partenaire pour la compagnie <strong>{{ form.company.name }}</strong> alors que la compagnie n'a pas de courriel de contact de défini.
                        </div>
                        <template v-slot:action>
                            <q-btn flat color="white" label="Corriger le contact" to="companies" />
                        </template>
                    </q-banner>
                    <q-banner rounded inline-actions class="bg-orange-2 q-mb-lg" v-if="isSynced">
                        <template v-slot:avatar>
                            <q-icon name="cloud" color="orange" />
                        </template>
                        Ce compte est synchronisé. Les champs contenant de l'information synchronisée ont été désactivés.
                        <div class="row">
                            <small>
                                Dernière synchronisation : {{ (form.synced_at) ? form.synced_at : 'jamais' }}
                            </small>
                            <small class="q-ml-auto">
                                Identifiant de synchronisation : <span>{{ (form.sync_external_id) ? form.sync_external_id : 'n/d' }}</span>
                            </small>
                        </div>
                    </q-banner>

                    <form
                        @submit.prevent="saveItem(form, $event)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" @click.stop.prevent="resetPassword()" class="o-button -gray -lg" :loading="$apollo.loading" color="secondary"  v-if="form.id && !form.deleted_at" :disabled="passwordResetSent">
                                    <span v-if="passwordResetSent">
                                        Lien de réinitialisation envoyé
                                    </span>
                                    <span v-else>
                                        Réinitialiser le mot de passe
                                    </span>
                                    <q-icon name="mail" class="o-ico -right" />    
                                </button>
                                <button @click.stop="restoreUserProfile()" type="button" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-if="form.id && form.deleted_at">
                                    Restaurer le profil
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h2 class="o-form__title" v-if="form.id==0">Inviter un nouvel utilisateur</h2> -->
                            <!-- <h2 class="o-form__title" v-if="form.id>0">Modifier un profil utilisateur</h2> -->
                            <div class="o-form__item" v-if="form.id == 0">
                                <!-- <Input
                                    ref="input-name"
                                    v-model="form.name"
                                    placeholder="Prénom Nom"
                                    required=true
                                    error-message="Ce champ est requis"
                                    label="Nom"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                /> -->
                                <Input
                                    ref="input-first_name"
                                    v-model="form.first_name"
                                    placeholder="Prénom"
                                    required=true
                                    error-message="Ce champ est requis"
                                    label="Prénom"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item" v-if="form.id == 0">
                                <Input
                                    ref="input-last_name"
                                    v-model="form.last_name"
                                    placeholder="Nom de famille"
                                    error-message="Ce champ est requis"
                                    label="Nom de famille"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />

                                <div class="o-form__item" v-if="form.is_synched">Compte synchronisé</div>
                            </div>
                            <div class="o-form__item"  v-if="form.id == 0">
                                <Input
                                    ref="input-email"
                                    v-model="form.email"
                                    placeholder="Courriel"
                                    required=true
                                    error-message="Ce champ est requis"
                                    label="Courriel"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                                <!-- <small v-if="form.id && form.role == 'PARTNER' && form.company.contact_email && form.company.contact_email != ''">
                                    Planificateur   : {{ form.company.contact_email }}
                                </small> -->
                            </div>
                            <div class="o-form__item" v-if="form.id==0">
                            </div>
                            <div class="o-form__item q-my-md" v-if="form.id==0">
                                <Input
                                    type="password"
                                    v-model="form.password"
                                    placeholder="Mot de passe"
                                    autocomplete="off"
                                    required=true
                                    label="Mot de passe"
                                    :error="newPasswordValid"
                                    :error-message="newPasswordValidMSG"
                                    @input="newPassword=$event"
                                    ref="newPassword"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item q-my-md" v-if="form.id==0">
                                <Input
                                    type="password"
                                    v-model="form.password_confirmation"
                                    placeholder="Confirmer le mot de passe"
                                    autocomplete="off"
                                    required=true
                                    label="Confirmer le mot de passe"
                                    :error="newPasswordConfirmValid"
                                    error-message="Le mot de passe ne correspond pas au nouveau mot de passe"
                                    @input="newPasswordConfirmValid=isSame($event, 'newPassword')"
                                    ref="newPasswordConfirm"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>

                            <div class="o-form__item q-my-md" v-if="form.id == 0">
                                <Select
                                    v-model="form.role"
                                    :options="rolesOptions"
                                    :clearable="false"
                                    label="Role / Accès"
                                    placeholder="Choisir le role"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />

                            </div>


                            <div class="o-form__inner" v-if="form && form.id>0">

                                <!-- <div class="o-form__item full-width">
                                    <Input
                                        ref="input-name"
                                        v-model="form.name"
                                        placeholder="Prénom Nom"
                                        required=true
                                        error-message="Ce champ est requis"
                                        label="Nom"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div> -->

                                <div class="o-form__item " v-if="form && form.id>0">
                                    <Input
                                        id="userProfileFirstName"
                                        v-model="form.first_name"
                                        placeholder="Prénom"
                                        label="Prénom"
                                        required=true
                                        error-message="Ce champ est requis"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>
                                <div class="o-form__item " v-if="form && form.id>0">
                                    <Input
                                        id="userProfileLastName"
                                        v-model="form.last_name"
                                        placeholder="Nom de famille"
                                        label="Nom de famille"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                        required=false
                                    />
                                </div>

                                <div class="o-form__item full-width q-mb-lg" v-if="form && form.id>0">
                                    <Input
                                        id="userProfileTitle"
                                        v-model="form.title"
                                        placeholder="ex. Chargé de projet"
                                        label="Titre"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>


                            <div class="o-form__item q-mb-lg">
                                <Input
                                    ref="input-email"
                                    v-model="form.email"
                                    placeholder="Courriel"
                                    required=true
                                    error-message="Ce champ est requis"
                                    label="Courriel"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    size="sm"
                                    :readonly="isSynced"
                                />
                                <!-- <small v-if="form.id && form.role == 'PARTNER' && form.company.contact_email && form.company.contact_email != ''">
                                    Planificateur   : {{ form.company.contact_email }}
                                </small> -->
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.company.contact_email"
                                    placeholder="Courriel"
                                    required=true
                                    error-message="Ce champ est requis"
                                    label="Courriel du planificateur"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    readonly
                                    type="email"
                                    v-if="form.role == 'PARTNER' || (form.role.value && form.role.value == 'PARTNER')"    
                                />
                                <!-- <small v-if="form.id && form.role == 'PARTNER' && form.company.contact_email && form.company.contact_email != ''">
                                    Planificateur   : {{ form.company.contact_email }}
                                </small> -->
                            </div>



                                <div class="o-form__item">
                                    <Input
                                        v-model="form.phone_work"
                                        placeholder="(111) 111-1111"
                                        label="Téléphone (travail)"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input
                                        v-model="form.phone_home"
                                        placeholder="(111) 111-1111"
                                        label="Téléphone (maison)"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input
                                        v-model="form.phone_mobile"
                                        placeholder="(111) 111-1111"
                                        label="Téléphone (mobile)"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>

                                <div class="o-form__item  q-mb-lg"></div>

                                <div class="o-form__item">
                                    <Input
                                        v-model="form.street"
                                        placeholder="Rue"
                                        label="Adresse"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input
                                        v-model="form.town"
                                        placeholder="Ville"
                                        label="Ville"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input
                                        v-model="form.state"
                                        placeholder="ex. Qc"
                                        label="Province"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input
                                        v-model="form.country"
                                        placeholder="Pays"
                                        label="Pays"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input
                                        v-model="form.zipcode"
                                        placeholder="ex. A1A 1A1"
                                        label="Code postal"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                    />
                                </div>

                                <div class="o-form__item  q-mb-lg"></div>

                                <div class="o-form__item">
                                    <Input
                                        v-model="form.distance"
                                        placeholder="ex. 10"
                                        label="Distance du bureau (km)"
                                        suffix="km"
                                        mask="#############"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>
                                <div class="o-form__item q-mb-lg">
                                    <Select
                                        :options="orientations"
                                        placeholder="Choisir une compagnie"
                                        label="Distance du bureau (orientation)"
                                        v-model="form.distance_orientation"
                                        :clearable="false"
                                        emit-value
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>

                                <div class="o-form__item">
                                    <!-- <div class="o-form__item__text">
                                        Role: {{ listbox.selectedItem.role }}
                                    </div> -->
                                    <Select
                                        v-model="form.role"
                                        :options="rolesOptions"
                                        :clearable="false"
                                        label="Role / Accès"
                                        placeholder="Choisir type de resource"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />

                                </div>
                                <!-- <div class="o-form__item">
                                    <div class="o-form__item__text">
                                        is_owner: {{ listbox.selectedItem.is_owner }}
                                    </div>
                                </div> -->
                                <div class="o-form__item">
                                    <Select
                                        :options="companies.data"
                                        placeholder="Choisir une compagnie"
                                        label="Compagnie"
                                        v-model="form.company"
                                        :clearable="false"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                        :readonly="isSynced"
                                        icon="bookmark"
                                        :icon-color="(form.company.categories.length) ? form.company.categories[0].color:''"
                                    >
                                    </Select>
                                </div>

                                <div class="o-form__item">
                                    <Input v-model="form.url1" label="URL externe (url1)" 
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input v-model="form.url2" label="URL externe (url2)" 
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>

                                <!-- <div class="o-form__item -split"></div> -->
                                <!-- <h3 class="o-form__title">Disponibilité</h3> -->
                                
                                <div class="o-form__item">
                                    <DatePicker class="" v-model="form.hiring_date" placeholder="AAAA-MM-DD" label="Date d'embauche" :clearable="true" 
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <Input v-model="form.externalID" label="ID Externe" 
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>

                                <div class="o-form__item">
                                    <Input
                                        type="textarea"
                                        v-model="form.internal_notes"
                                        placeholder="Note interne"
                                        label="Note interne"
                                        autogrow
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                    <q-item-label caption class="q-mt-sm">
                                        Les notes internes ne sont pas visibles que par un administrateur.
                                    </q-item-label>

                                </div>
                                <div class="o-form__item">
                                    <q-item tag="label">
                                        <q-item-section side style="justify-content: start">
                                            <q-checkbox
                                                size="xs"
                                                dense
                                                v-model="form.ignore_tracking"
                                            />
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label style="font-size: 12px; font-weight: 600;">Ne pas suivre la disponibilité</q-item-label>
                                            <q-item-label caption>L'employé est toujours disponible pour une affectation et aucun conflit d'affectation ne sera rapporté.<br>Ex. Sous-traitant</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </div>


                                <div class="o-form__item splitter"></div>
                                <h2 class="o-form__title">Absences</h2>
                                <div class="o-form__item">
                                    <DateRangesPicker
                                        v-model="addAbsenceDates"
                                        v-bind:selectedDates="selectedDates"
                                        :range="true"
                                        :multiple="true"
                                        :error="addAbsenceDatesError"
                                        @input="addAbsenceDatesError=false"
                                        :filled="false"
                                        dense
                                        :outlined="true"
                                    />
                                </div>
                                <div class="o-form__item">
                                    <q-btn-dropdown
                                        size="sm"
                                        color="white"
                                        text-color="blue"
                                        label="Ajouter une absence"
                                    >
                                    <q-list>
                                        <q-item clickable v-close-popup
                                            :key="'at'+at"
                                            v-for="(absenceType, at) in absenceTypes"
                                            @click="addAbsence(absenceType)"
                                        >
                                            <q-item-section side>
                                                <q-avatar :style="'background-color:'+absenceType.color" text-color="white" size="16px" />
                                            </q-item-section>
                                            <q-item-section>
                                                <q-item-label>
                                                    {{absenceType.name}}
                                                </q-item-label>
                                            </q-item-section>
                                        </q-item>
                                    </q-list>
                                    </q-btn-dropdown>
                                </div>
                                <table class="o-form__item__table">
                                    <tr
                                        :key="'al'+al"
                                        v-for="(absence, al) in absenceDates"
                                    >
                                        <td class="text-no-wrap">
                                            <q-avatar v-if="absence.dates[0] && absence.dates[0].type" class="q-mr-sm" :style="'background-color:'+absence.dates[0].type.color" text-color="white" size="16px" />
                                            {{ absence.dates[0].type.name }}
                                        </td>
                                        <td class="text-no-wrap" v-if="absence.dates.length==1">le {{ absence.dates[0].date }}</td>
                                        <td class="text-no-wrap" v-else>du {{ absence.dates[0].date }} au {{ absence.dates[absence.dates.length-1].date }}</td>
                                        <td class="-cell-grow">
                                            <q-icon name="cancel" color="red" class="cursor-pointer" 
                                                @click="removeAbsence(absence.rangeID)"
                                            />
                                        </td>
                                    </tr>
                                </table>



                                <div class="o-form__item splitter"></div>
                                <h2 class="o-form__title">Véhicules</h2>
                                <div class="o-form__item">
                                    <q-item tag="label">
                                        <q-item-section side style="justify-content: start">
                                            <q-checkbox
                                                size="xs"
                                                dense
                                                v-model="form.vehicule_available"
                                                :disable="!$generalSettings.settings.staffVehiculeRessourceType || $generalSettings.settings.staffVehiculeRessourceType=='0'  ? true : false"
                                            />
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label style="font-size: 12px; font-weight: 600;">Véhicule disponible pour transport</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </div>
                                <div class="o-form__item">
                                    <q-btn
                                        size="sm"
                                        color="white"
                                        text-color="blue"
                                        icon-right="add"
                                        :disable="form.vehicule_available && $generalSettings.settings.staffVehiculeRessourceType ? false : true"
                                        @click.prevent="addVehicule()"
                                    >
                                        Ajouter un véhicule
                                    </q-btn>
                                </div>

                                <div class="o-form__item" v-if="!$generalSettings.settings.staffVehiculeRessourceType  || $generalSettings.settings.staffVehiculeRessourceType=='0'">
                                    <div class="o-error-hint">Le paramètre "Type de ressource pour véhicules employé" n'est pas définie. <a href="/settings/general-settings">Cliquez ici</a> pour définir le paramètre</div>
                                </div>

                                <div :key="i" v-for="(vehicule, i) in form.vehicules" class="o-form__inner">
                                    <div class="o-form__item">
                                        <Input
                                            v-model="form.vehicules[i].name"
                                            label="Véhicule"
                                            placeholder="Véhicule"
                                            :disable="form.vehicule_available && $generalSettings.settings.staffVehiculeRessourceType ? false : true"
                                            required=true
                                            error-message="Ce champ est requis"
                                            :filled="false"
                                            dense
                                            :outlined="true"

                                        />
                                    </div>
                                    <div class="o-form__item">
                                        <Input
                                            type="textarea"
                                            v-model="form.vehicules[i].description"
                                            placeholder="Ex. nombre de places, année, ..."
                                            label="Description du véhicule"
                                            :autogrow="true"
                                            :disable="form.vehicule_available && $generalSettings.settings.staffVehiculeRessourceType ? false : true"
                                            afterIcon="cancel"
                                            afterIconColor="red"
                                            @afterIcon-click="deleteVehicule(vehicule)"
                                            :filled="false"
                                            dense
                                            :outlined="true"
                                        />
                                    </div>
                                </div>

                                <div class="o-form__item splitter"></div>
                                <h2 class="o-form__title">Métiers</h2>
                                <div class="o-form__item -full">
                                    <connections
                                        v-bind:connections="connections.professions"
                                        @add-connection="addConnections('professions', $event)"
                                        @remove-connection="removeConnection('professions', $event)"
                                        @set-rating="setRating('professions', $event)"
                                    />
                                </div>
                                <div class="o-form__item splitter"></div>
                                <h2 class="o-form__title">Compétences</h2>
                                <div class="o-form__item -full">
                                    <connections
                                        v-bind:connections="connections.skills"
                                        @add-connection="addConnections('skills', $event)"
                                        @remove-connection="removeConnection('skills', $event)"
                                        @set-rating="setRating('skills', $event)"
                                    />
                                </div>
                                <div class="o-form__item splitter"></div>
                                <h2 class="o-form__title">Formations</h2>
                                <div class="o-form__item -full">
                                    <connections
                                        v-bind:connections="connections.courses"
                                        @add-connection="addConnections('courses', $event)"
                                        @remove-connection="removeConnection('courses', $event)"
                                        @set-rating="setRating('courses', $event)"
                                    />
                                </div>
                                <input v-if="form.id" type="hidden"
                                    v-model="form.id"
                                />
                            </div>
                            <div class="o-form__item"></div>
                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import listbox from '@/components/globals/Listbox';
    import connections from '@/components/globals/Connections';
    import { COMPANIES } from '@/graphql/company/queries'
    // import { INVITEUSER, UPDATEUSERPROFILE, DELETEUSERPROFILE, DETECTABSENCEERRORS } from '@/graphql/user/mutations'
    import { INVITEUSER, UPDATEUSERPROFILE, DELETEUSERPROFILE, DETECTABSENCEERRORS, REQUESTPASSWORDRESET, RESTOREPROFILE } from '@/graphql/user/mutations'
    import { ALLUSERPROFILES, MYPROFILE, ROLES } from '@/graphql/user/queries'
    import { PROFESSIONS, SKILLS, COURSES } from '@/graphql/tag/queries'
    import { ABSENCETYPES } from '@/graphql/absence/queries'
    import { remove__typename, removeNULL, flattenRatingPivots, roleName } from '@/js/utilities'
    import { v4 as uuidv4 } from 'uuid';
    import {hexColorFromString} from '@/js/utilities'
    import {getDatesBetween} from '@/js/dateUtilities'
    import moment from 'moment';
    // import orderBy from "lodash/orderBy";
    import _ from "lodash";
    // import groupBy from "lodash/groupBy";

    export default {
        name: 'userProfiles',
        components: {
            listbox,
            connections,
        },
        data(){
            return {
                passwordResetResponse: null,
                passwordResetSent: false,
                newPassword: null,
                newPasswordValid: false,
                newPasswordValidMSG: 'Ce champ est requis',
                newPasswordConfirmValid: false,
                rolesOptions: [],
                addAbsenceDates: [],
                addAbsenceDatesError: false,
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: [],
                    addButton: 'Nouvel utilisateur',
                    deleteButton: 'Supprimer',
                    copyButton: false,
                    searchable: 'Rechercher / filtrer'
                },
                userProfileVariables: null,
                connections: {
                    professions: { all: [], currents: [], useRating:true, searchListAll: '' },
                    skills: { all: [], currents: [], useRating:true, searchListAll: '' },
                    courses: { all: [], currents: [], useRating:true, searchListAll: '' },
                //     customTags: { all: [], currents: [], searchListAll: '' },
                },
                form: {},
                newItem: {
                    id: 0,
                    name: null,
                    email: '',
                    password: '',
                    password_confirmation: '',
                    phone_work: null,
                    phone_home: null,
                    phone_mobile: null,
                    street: null,
                    town: null,
                    state: null,
                    country: null,
                    zipcode: null,
                    company_id: 0,
                    is_owner: false,
                    role: "STAFF",
                    professions: [],
                    skills: [],
                    courses: [],
                    customTags: [],
                    vehicule_available: false,
                    vehicules: []
                },
                newVehicule: {
                    id:0,
                    name: null,
                    description: null,
                    applyTo: 'USERPROFILES',
                    isUserVehicule: true
                },
                orientations: [
                    {
                        label: 'Nord',
                        value: 'N'
                    },
                    {
                        label: 'Nord-est',
                        value: 'NE'
                    },
                    {
                        label: 'Est',
                        value: 'E'
                    },
                    {
                        label: 'Sud-est',
                        value: 'SE'
                    },
                    {
                        label: 'Sud',
                        value: 'S'
                    },
                    {
                        label: 'Sud-ouest',
                        value: 'SO'
                    },
                    {
                        label: 'Ouest',
                        value: 'O'
                    },
                    {
                        label: 'Nord-ouest',
                        value: 'NO'
                    }
                ],
                showDeleted: false,
                orderByHiringDate: false,
                filterByRole: 'ALL',
                loadingUserProfiles: false,
            }
        },
        mounted: async function(){
            // this.listbox.selectedItem=Object.assign({}, this.newItem);
            // this.form = Object.assign({}, this.newItem);
            this.setNewItem()
            this.connections.professions.currents = Object.assign([]);
            this.connections.skills.currents = Object.assign([]);
            this.connections.courses.currents = Object.assign([]);
        },
        computed: {

            isSynced() {
                let isSynced = false
                if(this.$generalSettings.settings.enableUsersSyncModule && this.form.synced_at) isSynced = true
                return isSynced
            },

            roleFilterOptions() {
                // console.log('this.rolesOptions', this.rolesOptions)
                let options = [
                    {
                        value: 'ALL',
                        label: 'Tous les rôles'
                    },
                    ...this.rolesOptions
                ];

                return options;
            },
        
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
            absenceDates(){
                if(!this.form.absences) return [];

                let absenceDates=[];
                absenceDates=_.chain(this.form.absences)
                                .groupBy('rangeID')
                                .map((dates, rangeID) => ({ dates, rangeID }))
                                .value();
                return absenceDates;
            },
            selectedDates(){
                if(!this.addAbsenceDates) return new Array();

                let dates=Object.assign([], this.addAbsenceDates)
                dates.forEach(function(date, index){
                    if(date.from && date.from == date.to) dates[index]=date.from;
                })
                // this.setShiftDates(dates);
                return dates.sort(function(a,b){
                    let aDate=a, bDate=b;
                    if(a.from){
                        aDate=a.from
                    }
                    if(b.from){
                        bDate=b.from
                    }
                    return new Date(aDate)-new Date(bDate)
                })
            },
        },
        watch: {

            'listbox.listItems': function () {
                this.listbox.listItems.forEach(item => {
                    if (this.$generalSettings.settings.enableUsersSyncModule && item.synced_at) {
                        item.icon = "cloud";
                        item.iconColor = 'orange-2';
                    }
                    if(item.company?.categories.length>0) item.color = item.company.categories[0].color;
                })

                if (this.showDeleted) {
                    this.listbox.listItems.forEach(item => {
                        if (!item.deleted_at) {
                            this.listbox.listItems = this.listbox.listItems.filter(profile => profile.id != item.id)
                        }
                    })

                }
            },
            
            newPassword: function(){
                // if(!this.newPassword) return false;
                let complexityError=false;
                this.newPasswordValid=false;

                if(!this.newPassword || this.newPassword==""){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Ce champ est requis.";
                    return;
                }

                if( this.newPassword.length < 8 ){
                    complexityError=true;
                } 
                if( ! /\d/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[a-z]/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[A-Z]/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[!@#$%^&*)(+=._-]/.test(this.newPassword) ) complexityError=true;

                if(complexityError){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Le nouveau mot de passe doit contenir au minimum 8 caractères et au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.";
                }
            }
        },
        methods: {
			async resetPassword() {
                this.$apollo.mutate({
                    mutation: REQUESTPASSWORDRESET,
                    variables: { 
                        email: this.form.email,
                    },
                }).then(() => {
                    this.passwordResetSent=true;
                    this.passwordResetResponse="Un lien de réinitialisation a été envoyé par courriel.<br><br><a href='/login'>Cliquez ici</a> pour revenir à l'écran de connexion."
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: e.message, caption: ''});
                })

			},

            isSame(needle, haystack){
                if(needle=='' || !this.$refs[haystack]) return false;
                return needle != this.$refs[haystack].value
            },

            removeAbsence(rangeID){
                if(!this.form.deleteAbsences) this.form.deleteAbsences=[];

                this.form.absences.forEach(function(item){
                    if(item.rangeID==rangeID) this.form.deleteAbsences.push(item.id);
                }.bind(this))
                this.form.absences=this.form.absences.filter(item => item.rangeID !== rangeID);
            },
            addAbsence(absenceType){
                if(!this.addAbsenceDates) return this.addAbsenceDatesError=true;
                this.addAbsenceDates.forEach(function(date){
                    let rangeID='rg-' + uuidv4();

                    if(!date.from){
                        let absence={
                            id: 'abs-' + uuidv4(),
                            absenceTypeID: absenceType.id,
                            date: date,
                            rangeID: rangeID,
                            type: absenceType
                        }
                        this.form.absences.push(absence);
                    }else{
                        let dates=getDatesBetween(date.from, date.to);

                        dates.forEach(function(dater){
                            let absence={
                                id: 'abs-' + uuidv4(),
                                absenceTypeID: absenceType.id,
                                date: moment(dater).format('YYYY-MM-DD'),
                                rangeID: rangeID,
                                type: absenceType
                            }
                            this.form.absences.push(absence);
                        }.bind(this))
                    }
                }.bind(this))
                this.addAbsenceDates=null;
            },
            hexColorFromString(string){
                return hexColorFromString(string)
            },
            setSelected(item){
                this.passwordResetSent=false;
                // if (!item) {
                //     this.setNewItem()
                // } else {
                    this.listbox.selectedItem = JSON.parse(JSON.stringify(item));
                    this.form=JSON.parse(JSON.stringify(item));
                // }
                this.connections.professions.currents=[];
                this.connections.professions.currents = Object.assign([], item.professions);
                this.connections.skills.currents = Object.assign([], item.skills);
                this.connections.courses.currents = Object.assign([], item.courses);
                this.connections.professions.searchListAll='';
                this.connections.skills.searchListAll='';
                this.connections.courses.searchListAll='';
                this.addAbsenceDates=null;
                this.addAbsenceDatesError=null;
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form=Object.assign({}, this.newItem);
                this.connections.professions.currents = [];
                this.connections.skills.currents = [];
                this.connections.courses.currents = [];

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            addVehicule(){
                this.newVehicule.id='veh-' + uuidv4();
                this.form.vehicules.push(Object.assign({}, this.newVehicule));
            },
            deleteVehicule(vehicule){
                if(!this.form.deleteVehicule) this.form.deleteVehicule=[];
                this.form.deleteVehicule.push(vehicule.id);
                this.form.vehicules=this.form.vehicules.filter(item => item.id !== vehicule.id);
            },
            addConnections(prop, item){
                item.rating=0;
                this.connections[prop].currents.push(item);
                this.form[prop]=Object.assign([], this.connections[prop].currents);
            },
            removeConnection(prop, item){
                this.form[prop]=this.form[prop].filter(function(current){

                    return current.id !== item.id;
                })
                this.connections[prop].currents=Object.assign([], this.form[prop]);
            },
            setRating(prop, obj){
                this.form[prop].forEach(function(current){
                    if(current.id == obj.item.id){
                        current.rating = obj.rating;
                    }
                })
                this.connections[prop].currents=Object.assign([], this.form[prop]);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETEUSERPROFILE,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.userProfiles) this.$apollo.queries.userProfiles.refetch()
                    }
                    // update: (store, { data: { deleteUserProfile } }) => {
                    //     const data = store.readQuery({ query: ALLUSERPROFILES })
                    //     data.userProfiles.data = data.userProfiles.data.filter(item => item.id !== deleteUserProfile.id);
                    //     store.writeQuery({
                    //         query: ALLUSERPROFILES,
                    //         data,
                    //     })
                    //     this.setNewItem()
                    //     return data;
                    // }
                })
                // this.setNewItem()
            },
            detectAbsenceErrors(userProfileID){
                this.$q.notify({ timeout: 0, progress: false, spinner: true, message: "Sauvegarde du profile et détection d'erreurs d'absences en cours..."})
                this.$apollo.mutate({
                    mutation: DETECTABSENCEERRORS,
                    variables: {
                        userProfileID: userProfileID
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Détection d'erreurs d'absences complétée"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {

                })
            },

            restoreUserProfile() {
                this.$apollo.mutate({
                    mutation: RESTOREPROFILE,
                    variables: { userProfileID: this.form.id },
                    }).then((data) => {
                        // data.data.restoreUserProfile = flattenRatingPivots(data.data.restoreUserProfile)
                        this.setNewItem()
                        this.$q.notify({ type: 'positive', message: "Utilisateur : " + this.form.name, caption: "Profile restauré" })
                        this.detectAbsenceErrors(data.data.restoreUserProfile.id)
                        if (this.$apollo.queries.userProfiles) this.$apollo.queries.userProfiles.refetch()
                    }).catch(e => {
                        if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                    }).finally(() => {
                    })
            },

            saveItem(data, e) {
                e.preventDefault();
                e.stopPropagation();
                let form=JSON.parse(JSON.stringify(data));
                
                form.tags=[];
                form=remove__typename(form)
                form.professions.forEach(function(tag){
                    let tagItem={};
                    if(tag.id) tagItem.id=tag.id;
                    if(tag.rating) tagItem.rating=tag.rating;
                    form.tags.push(tagItem);
                })
                form.skills.forEach(function(tag){
                    let tagItem={};
                    if(tag.id) tagItem.id=tag.id;
                    if(tag.rating) tagItem.rating=tag.rating;
                    form.tags.push(tagItem);
                })
                form.courses.forEach(function(tag){
                    let tagItem={};
                    if(tag.id) tagItem.id=tag.id;
                    if(tag.rating) tagItem.rating=tag.rating;
                    form.tags.push(tagItem);
                })
                if(form.company) form.company_id=form.company.id

                
                if(form.vehicules){
                    form.vehicules.forEach(function(vehicule){
                        vehicule.type={};
                        vehicule.type.connect=this.$generalSettings.settings.staffVehiculeRessourceType
                        delete vehicule.userProfile;
                    }.bind(this))
                }

                if(form.absences){
                    form.absences.forEach(function(absence){
                        delete absence.type;
                    }.bind(this))
                }

                if (form.role && form.role.value) form.role = form.role.value
                if (!form.hiring_date) form.hiring_date=''

                form = removeNULL(form);

                if(parseInt(form.id)==0){
                    this.$apollo.mutate({
                        mutation: INVITEUSER,
                        variables: { ...form },
                        // update: (store, { data: { inviteUser } }) => {
                        //     const data = store.readQuery({ query: ALLUSERPROFILES })
                        //     inviteUser.userProfiles.data.forEach(function(newUserProfile){
                        //         newUserProfile=flattenRatingPivots(newUserProfile);
                        //         data.userProfiles.data.push(newUserProfile);
                        //         this.setSelected(newUserProfile);
                        //     }.bind(this));
                        //     store.writeQuery({
                        //         query: ALLUSERPROFILES,
                        //         data,
                        //     })

                        //     return data;
                        // }
                    }).then(() => {
                        this.$q.notify({type: 'positive', message: "Utilisateur : "+form.name, caption: "Informations sauvegardées"})
                    }).catch(e => {
                        if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                    }).finally(() => {
                        if (this.$apollo.queries.userProfiles) this.$apollo.queries.userProfiles.refresh()
                        this.listbox.searchListAll = form.name
                        this.setNewItem()
                    })
                }else{
                    this.$apollo.mutate({
                        mutation: UPDATEUSERPROFILE,
                        variables: { ...form },
                    }).then((data) => {
                        data.data.updateUserProfile=flattenRatingPivots(data.data.updateUserProfile)
                        this.setSelected(data.data.updateUserProfile);
                        this.$q.notify({type: 'positive', message: "Utilisateur : "+form.name, caption: "Informations sauvegardées"})
                        this.detectAbsenceErrors(data.data.updateUserProfile.id)

                    }).catch(e => {
                        if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                    }).finally(() => {
                        // console.log(this.$apollo.queries)
                        if (this.$apollo.queries.userProfiles) this.$apollo.queries.userProfiles.refresh()
                    })
                }
            }
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(myProfile) {
                    return myProfile
                }
            },
            absenceTypes: {
                query: ABSENCETYPES,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                // update(data) {
                //     this.listbox.listItems = Object.assign([], data.absenceTypes)
                // }
            },
            companies: {
                query: COMPANIES,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    let variables = {
                        first: 100,
                        // role: [this.filterByRole]
                    }
                    return variables
                },
            },
            professions: {
                query: PROFESSIONS,
                // fetchPolicy: 'cache-and-network',
                fetchPolicy: 'no-cache',
                error(error) {
                    if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                },
                update(professions) {
                    professions.professions.forEach(function(item){
                        delete item.__typename;
                    })
                    this.connections.professions.all = Object.assign([], professions.professions)
                    this.connections.professions.all.forEach(function (item) {
                        item.rating = 0;
                    })
                    return professions;
                }
            },
            skills: {
                query: SKILLS,
                // fetchPolicy: 'cache-and-network',
                fetchPolicy: 'no-cache',
                error(error) {
                    if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                },
                update(skills) {
                    this.connections.skills.all = Object.assign([], skills.skills)
                    this.connections.skills.all.forEach(function (item) {
                        item.rating = 0;
                    })
                    return skills;
                }
            },
            courses: {
                query: COURSES,
                // fetchPolicy: 'cache-and-network',
                fetchPolicy: 'no-cache',
                error(error) {
                    if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                },
                update(courses) {
                    this.connections.courses.all = Object.assign([], courses.courses)
                    this.connections.courses.all.forEach(function (item) {
                        item.rating = 0;
                    })
                    return courses;
                }
            },
            userProfiles: {
                query: ALLUSERPROFILES,
                // fetchPolicy: 'cache-and-network',
                fetchPolicy: 'no-cache',
                // watchLoading(isLoading) {
                //     console.log('isLoading', isLoading)
                //     this.loadingUserProfiles=isLoading;
                // },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables(){
                    let orderBy = (this.orderByHiringDate) ? 'hiring_date' : 'name';
                    let variables = {
                        orderBy: orderBy,
                        trashed: this.trashed,
                        // role: [this.filterByRole]
                    }
                    if (this.filterByRole != 'ALL') variables.role = [this.filterByRole]
                    this.loadingUserProfiles=true;
                    return variables
                },
                update(userProfiles) {
                    userProfiles.allUserProfiles.forEach(function(item){
                        flattenRatingPivots(item);
                    })
                    this.listbox.listItems = Object.assign([], userProfiles.allUserProfiles)
                    this.loadingUserProfiles=false;
                    return userProfiles;
                },
                // variables(){
                //     return {
                //         ids: null
                //     }
                // }
            },
            roles: {
                query: ROLES,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.rolesOptions=[];
                    data.__type.enumValues.forEach(function(item){
                        this.rolesOptions.push(
                            {
                                value: item.name,
                                label: roleName(item.name)
                            }
                        )
                    }.bind(this))
                    // return data.__type.enumValues
                }
            },

        },

    }
</script>
<style lang="scss" scoped>

</style>
